import request from "@/utils/request";

/**
 * 获取学校列表 （需登录）
 * @returns {Promise} 返回学校列表的Promise对象
 */
export function getSchoolList() {
  return request({
    url: '/manage/school_list',
    method: 'get'
  });
}

/**
 * 获取学校列表 (无需登录)
 * @returns {Promise} 返回学校列表的Promise对象
 */
export function getSchoolListNoLogin() {
  return request({
    url: '/manage/school_list_noLogin',
    method: 'get'
  });
}

/**
 * 通过id获取学校详细信息
 * @param {string} params.id - 学校id
 * @returns {Promise} 返回学校信息的Promise对象
 */
export function getSchoolById(params) {
  return request({
    url: '/manage/school_detail',
    method: 'get',
    params
  });
}

/**
 * 添加学校
 * @param {Object} data - 学校信息数据
 * @returns {Promise} 返回添加结果的Promise对象
 */
export function addSchool(data) {
  return request({
    url: '/manage/school_add',
    method: 'post',
    data
  });
}

/**
 * 更新学校信息
 * @param {Object} data - 学校信息数据
 * @returns {Promise} 返回更新结果的Promise对象
 */
export function updateSchool(data) {
  return request({
    url: '/manage/school_update',
    method: 'post',
    data
  });
}

/**
 * 删除学校
 * @param {string} params.id - 学校id
 * @returns {Promise} 返回删除结果的Promise对象
 */
export function deleteSchool(params) {
  return request({
    url: '/manage/school_del',
    method: 'get',
    params
  });
}

/**
 * 通过名称模糊查询学校信息
 * @param {string} params.name - 学校名称
 * @returns {Promise} 返回学校信息的Promise对象
 */
export function searchSchoolByName(params) {
  return request({
    url: '/manage/school_search',
    method: 'get',
    params
  });
}

// 学校账号相关-------------------------------------------------------
/**
 * 获取学校账号列表
 * @param {string} params.schoolId - 学校ID
 * @param {number} params.PageNum - 页码
 * @param {number} params.PageSize - 每页条数
 * @returns {Promise} 返回学校账号列表的Promise对象
 */
export function getSchoolAccounts(params) {
  return request({
    url: '/manage/yee_list',
    method: 'get',
    params
  });
}

/**
 * 查询学校账号详细信息
 * @param {string} params.schoolId - 学校id
 * @param {string} params.id - ID编号
 * @returns {Promise} 返回学校账号信息的Promise对象
 */
export function getSchoolAccountById(params) {
  return request({
    url: '/manage/yee_select',
    method: 'get',
    params
  });
}

/**
 * 添加学校账号 , 暂时没有这个接口
 * @param {Object} data - 学校账号信息数据
 * @returns {Promise} 返回添加结果的Promise对象
 */
export function addSchoolAccount(data) {
  return request({
    url: '/manage/yee_add',
    method: 'post',
    data
  });
}

/**
 * 更新学相关校账号信息
 * @param {Object} data - 学校账号信息数据
 * @returns {Promise} 返回更新结果的Promise对象
 */
export function updateSchoolAccount(data) {
  return request({
    url: '/manage/yee_update',
    method: 'post',
    data
  });
}

/**
 * 删除学校内相关账号
 * @param {string} params.schoolId - 请求参数
 * @param {string} params.id - 学校账号ID
 * @returns {Promise} 返回删除结果的Promise对象
 */
export function deleteSchoolAccount(params) {
  return request({
    url: '/manage/yee_delete',
    method: 'get',
    params
  });
}

/**
 * 激活学校内相关账号
 * @param {string} params.schoolId - 请求参数
 * @param {string} params.id - 学校账号ID
 * @returns {Promise} 返回激活结果的Promise对象
 */
export function activeSchoolAccount(params) {
  return request({
    url: '/manage/yee_active',
    method: 'get',
    params
  });
}

/**
 * 锁定/解锁学校内相关账号
 * @param {string} params.schoolId - 请求参数
 * @param {string} params.id - 学校账号ID
 * @returns {Promise} 返回锁定/解锁结果的Promise对象
 */
export function lockSchoolAccount(params) {
  return request({
    url: '/manage/yee_lock',
    method: 'get',
    params
  });
}


/**
 * 模糊查询学校账号信息
 * @param {object} params - 查询参数
 * @returns {Promise} 返回学校账号信息的Promise对象
 */
export function getSchoolAccountInfo(params) {
  return request({
    url: '/manage/yee_search',
    method: 'post',
    params
  });
}

/**
 * 批量修改学校账号密码
 * @param {object} params -查询参数(需要学校id和id)
 * @returns {object} 返回学校账号信息的promise对象
 */
export function batchResetSchoolAccountPassword(params) {
  return request({
    url: '/manage/yee_password',
    method: 'post',
    params
  });
}